// gotta make sure you have confetti installed, or available on window.confetti from CDN
// https://github.com/catdad/canvas-confetti

const defaultOpts = {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 }
};

const confettiBlaster = window.confetti;  // might not have it!

const fireConfetti = (options) => {
    const finalOpts = options ?? defaultOpts;
    if (confettiBlaster) {
        confettiBlaster(finalOpts);
    }
};


/* use fireConfettiFromElement like this:

const launchButton = this.$refs['launchButton'];
if (launchButton) {
    fireConfettiFromElement(launchButton);
}

make sure you have CDN script tag on the page, or you installed it from NPM

*/

const fireConfettiFromElement = (element) => {
    // pass in an HTMLElement (using vue $refs)
    // we'll figure out its center position using getBoundingClientRect
    // and fire confetti from there
    const domRect = element ? element.getBoundingClientRect() : null;
    if (!domRect) return;  // bail now if we didn't get something
    const bodyRect = document.body.getBoundingClientRect();
    const bodyWidth = bodyRect.width;
    const bodyHeight = bodyRect.height;
    /* domRect will be object like this:  
    bottom: 565.640625
    height: 60.390625
    left: 897.828125
    right: 1096.3125
    top: 505.25
    width: 198.484375
    x: 897.828125
    y: 505.25
    */
   const { height, left, top, width } = domRect;
   const centerX = left + (width / 2);
   const centerY = top + (height / 2);
   const xRatio = centerX / bodyWidth;
   const yRatio = centerY / bodyHeight;

   const customOpts = {
       particleCount: 100,
       spread: 90,
       origin: { x: xRatio, y: yRatio },
   };

   fireConfetti(customOpts);
}


export {
    fireConfetti,
    fireConfettiFromElement,
}